import fetch from "cross-fetch";
import {ApiPrefix, statusCheck, json, getCookie} from '../util/icwUtility';
import {actLoginTimedOut} from "./loginStateActions";


export const BIBLE_LIST_FETCH_BEGIN = 'BIBLE_LIST_FETCH_BEGIN'
function actBibleListFetchBegin() { return {type: BIBLE_LIST_FETCH_BEGIN} }

export const BIBLE_LIST_FETCH_SUCCESS = 'BIBLE_LIST_FETCH_SUCCESS'
export function actBibleListFetchSuccess(data) { return {type: BIBLE_LIST_FETCH_SUCCESS, data} }

export const BIBLE_LIST_FETCH_FAIL = 'BIBLE_LIST_FETCH_FAIL'
function actBibleListFetchFail(reason) {return { type: BIBLE_LIST_FETCH_FAIL, reason } }

export function actBibleListFetch() {
    return dispatch => {
        dispatch(actBibleListFetchBegin())
        return fetch(`${ApiPrefix}/bibles`, {
            headers: {"Authorization": getCookie('token')}
        })
            .then(statusCheck)
            .then(json)
            .then(data => dispatch(actBibleListFetchSuccess(data)))
            .catch(err => {
                if (err.status === 401) {
                    dispatch(actLoginTimedOut());
                }

                dispatch(actBibleListFetchFail(typeof(err) === "object" ? err.message : err))
            })
    }
}




